module.exports = __webpack_public_path__ + "img/integration-module-banner-1.d0a57aa4.png";